import template from "./settings.html";

const SettingsComponent = {
  template: template,
  controller: class SettingsController {
    /* @ngInject */
    constructor($rootScope, $filter, $state, OrganizationService, SweetAlertService, Notification, Tariff) {
      this.$rootScope = $rootScope;
      this.$filter = $filter;
      this.$state = $state;
      this.OrganizationService = OrganizationService;
      this.SweetAlertService = SweetAlertService;
      this.NotificationService = Notification;
      this.Tariff = Tariff;
    }

    async $onInit() {
      this.editableOrganization = angular.copy(this.$rootScope.organization);
    }

    async setApproveFromPublicView() {
      this.editableOrganization.settings.approveFromPublicView =
        !this.editableOrganization.settings.approveFromPublicView;
      this.OrganizationService.updateOrganization(this.editableOrganization).then((organization) => {
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")("notificationService.message.setApproveFromPublicView"),
        });
        this.editableOrganization = angular.copy(this.$rootScope.organization);
        this.$state.reload();
      });
    }

    async setPdfDownloadable() {
      this.editableOrganization.settings.pdfDownloadable = !this.editableOrganization.settings.pdfDownloadable;
      this.OrganizationService.updateOrganization(this.editableOrganization).then((organization) => {
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")("notificationService.message.setPdfDownloadable"),
        });
        this.editableOrganization = angular.copy(this.$rootScope.organization);
        this.$state.reload();
      });
    }

    async setEmailToCustomerOnAccept() {
      this.editableOrganization.settings.emailToCustomerOnAccept =
        !this.editableOrganization.settings.emailToCustomerOnAccept;
      this.OrganizationService.updateOrganization(this.editableOrganization).then((organization) => {
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")("notificationService.message.emailToCustomerOnAccept"),
        });
        this.editableOrganization = angular.copy(this.$rootScope.organization);
        this.$state.reload();
      });
    }

    async setQuoteLanguage(oldQuoteLanguage, newQuoteLanguage) {
      this.editableOrganization.settings.quoteLanguage = newQuoteLanguage;
      this.OrganizationService.updateOrganization(this.editableOrganization).then((organization) => {
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")("notificationService.message.setQuoteLanguage"),
        });
        this.editableOrganization = angular.copy(this.$rootScope.organization);
        this.$state.reload();
      });
    }

    async setCurrency(oldCurrency, newCurrency) {
      let updateTariffs = false;
      const tariffs = await this.Tariff.query();

      if (tariffs.length > 0) {
        const action = await this.SweetAlertService.updateTariffPrices();
        if (!action) return;
        updateTariffs = action === "update-tariffs";
      }

      this.editableOrganization.settings.currency = newCurrency;
      await this.OrganizationService.updateCurrency(this.editableOrganization, updateTariffs);
      if (updateTariffs) await this.SweetAlertService.tariffPricesUpdated();
      this.$state.reload();
    }
  },
};

export default SettingsComponent;
